import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore, collection, addDoc} from 'firebase/firestore';
import { getStorage } from "firebase/storage";



const firebaseConfig = {
    apiKey: "AIzaSyASkmDQMtCg297ir0nHRZfW7vkIR-Oi9bM",
    authDomain: "eyecare-digital-library.firebaseapp.com",
    projectId: "eyecare-digital-library",
    storageBucket: "eyecare-digital-library.firebasestorage.app",
    messagingSenderId: "927283904105",
    appId: "1:927283904105:web:e869b1f7795da301622cf8"
};

const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
const db = getFirestore(app);


export const storage = getStorage(app); 
export { auth, db, collection, addDoc };
